import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=97fa5aa8&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=97fa5aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fa5aa8",
  null
  
)

export default component.exports